// extracted by mini-css-extract-plugin
export default {"no-videos":"bSlajt","noVideos":"bSlajt","play":"keWmyJ","overlay-only":"wxqBau","overlayOnly":"wxqBau"};